import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import {
  fetchCurrentInstallationStatementByDeviceLink,
  fetchInstallationStatements,
  fetchInstallationStatementsByDeviceLink,
} from '../api/installation.api'
import { statementDtoToModelTransfomer } from '../api/transformer/statement-dto-to-model.transformer'
import { InstallationStatementModel } from 'src/Libs/installation-statement/models/statement'

interface InstallationStatementQueryFunctions {
  installationStatementsQueryFunction: () => Promise<InstallationStatementModel[] | undefined>
  installationStatementByDeviceLinkQueryFunction: () => Promise<InstallationStatementModel | null>
  currentInstallationStatementByDeviceLinkQueryFunction: () => Promise<InstallationStatementModel | null>
}

export const useInstallationStatementQueryFunctions = (
  installationId?: number,
  storageDeviceLinkId?: number
): InstallationStatementQueryFunctions => {
  const authFetch = useAuthFetchWithResponse()

  const installationStatementsQueryFunction = async (): Promise<InstallationStatementModel[] | undefined> => {
    const { error, hasErrors, value } = await fetchInstallationStatements(installationId, authFetch)
    if (hasErrors) {
      throw error || new Error('Error fetching installation statements')
    }

    return value?.map(statement => statementDtoToModelTransfomer(statement))
  }

  const installationStatementByDeviceLinkQueryFunction = async (): Promise<InstallationStatementModel | null> => {
    const { error, hasErrors, value } = await fetchInstallationStatementsByDeviceLink(installationId, storageDeviceLinkId, authFetch)

    if (hasErrors) {
      throw error || new Error('Error fetching installation statement by storage device link')
    }

    return value ? statementDtoToModelTransfomer(value) : null
  }

  const currentInstallationStatementByDeviceLinkQueryFunction = async (): Promise<InstallationStatementModel | null> => {
    const { error, hasErrors, value } = await fetchCurrentInstallationStatementByDeviceLink(installationId, storageDeviceLinkId, authFetch)

    if (hasErrors) {
      throw error || new Error('Error fetching current installation statement by storage device link')
    }

    return value ? statementDtoToModelTransfomer(value) : null
  }

  return {
    installationStatementsQueryFunction,
    installationStatementByDeviceLinkQueryFunction,
    currentInstallationStatementByDeviceLinkQueryFunction,
  }
}
